import styled from 'styled-components';

export const ListWrapper = styled.div`
    border-radius: 15px;
    padding: 1rem 1.5rem;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    width: 90%;
`;